const map = {
	"./archive_0/thumb.jpg": 6712,
	"./archive_10/thumb.jpg": 6467,
	"./archive_11/thumb.jpg": 3666,
	"./archive_12/thumb.jpg": 761,
	"./archive_9/thumb.jpg": 8121
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;